import * as React from 'react';
import { AppStoreType, IntegrationType, IssueSource, IssueSourceType, IssueState } from '@/types';
import { getIntegrationTypeForAppStoreType } from '@/helpers';
import IntegrationIcon from '@/components/icons/IntegrationIcon';
import runwayLogo from '../../../assets/integration-runway.svg';

export const CLOSED_ISSUE_STATES = [IssueState.FixMerged, IssueState.FixRejected, IssueState.NotAPriority];

export const iconForIssueSource = (
    source: IssueSource | undefined,
    appStoreType: AppStoreType | undefined,
    size = 16,
): React.ReactNode => {
    if (source?.type === IssueSourceType.Runway) {
        return <img src={runwayLogo} alt="Runway" width={size} height={size} />;
    }
    const derivedIntegrationType =
        source?.type === IssueSourceType.UserReviews && appStoreType ? getIntegrationTypeForAppStoreType(appStoreType)
        : source?.type === IssueSourceType.BetaFeedback ? IntegrationType.TestFlight
        : null;
    return <IntegrationIcon integrationId={derivedIntegrationType ?? source?.integrationType} size={size} />;
};
